<template>
  <div class="container">
    <v-dialog width="800px" v-model="dialog">
      <v-card>
        <v-card-title class="pl-4">
          <h3>Events made by: {{currUser}}</h3>
        </v-card-title>
        <v-list outlined mandatory max-height="500px" class="ma-0 pa-0 overflow-y-auto">
          <v-list-item v-for="(event, i) in currEvents" :key="i" :value="event">
            <v-list-item-icon>
              <v-icon v-text="$store.getters.eventToIcon(event)"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$store.getters.eventToText(event) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
    <v-data-table :headers="automaticDataHeaders" @click:row="clickRow" :items="data" :page.sync="page" :items-per-page="itemsPerPage" :loading="loading" hide-default-footer class="elevation-1" @page-count="pageCount = $event"></v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "AutomaticResults",
  data() {
    return {
      loading: true,
      page: 1,
      data: [],
      dialog: false,
      itemsPerPage: 10,
      pageCount: 0,
      model: 0,
      currEvents: [],
      currUser: "",
      automaticDataHeaders: [
        {
          text: "User",
          align: "start",
          sortable: false,
          value: "user",
          width: "500px",
        },
        {
          text: "Projects Finished",
          align: "start",
          value: "results.finishedProjects",
        },
        {
          text: "#Resources",
          align: "start",
          value: "numResources",
        },
        {
          text: "Profit",
          align: "start",
          value: "profit",
        },
        {
          text: "Automation",
          align: "start",
          value: "automationName",
        },
        {
          text: "Date",
          align: "start",
          value: "date",
        },
      ],
    };
  },
  methods: {
    
    clickRow(item) {
      if (item.events[0].startHour != null) {
        return;
      }
      this.currEvents = item.events;
      this.currUser = item.user;
      this.dialog = true;
    },
    updateData(data) {
      this.data = data;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 10px;
}
</style>